import {createAsyncThunk, createSelector, createSlice} from '@reduxjs/toolkit';
import {isEqual} from 'lodash';
import {IFiltersSliceState} from '../../DrilldownDashboardContainer/filters/filtersSlice';
import {RootState} from '../store';
import { getAllComments} from './allCommentsAPI';
import {buildHTMLFiltersSubtitle} from '../utils';

export interface IComment {
  comment: string;
  id: any;
  mood: string;
  period: string;
  qid:string;
  survey: string;
}

export interface IAllCommentsAPIResponse {
  values: IComment[]; 
  count: number;
  commentCount: number;
  segmentName: string;
  segmentCategory: string;
  periodLabel: string; 
  surveyLabel: string;
  avidLabel: string;
  question: string;
  commentType: string;
  shortCommentType: string;
  commentMood: string;
  commentDetailsUrl: string;
  sentiment: string;
}

interface IAllCommentState {
  isLoading: boolean;
  apiResponse: IAllCommentsAPIResponse;
  subtitle: any;
  commentCount: string;
  comments: any;
  commentMood: string;
}

const initialState: IAllCommentState = {
  isLoading: false,
  apiResponse: {
    values: [], 
    count: 0,
    commentCount: 0,
    segmentName: "",
    segmentCategory: "",
    periodLabel: "", 
    surveyLabel: "",
    avidLabel: "",
    question: "",
    commentType: "",
    shortCommentType: "",
    commentMood: "",
    commentDetailsUrl: "",
    sentiment: "",
  },
  subtitle: '',
  commentCount: '',
  comments:[],
  commentMood: '',
}

export const loadAllComments = createAsyncThunk(
  'allComments/get',
  async (filters: IFiltersSliceState) => {
    return  getAllComments(filters);
  }
);

export const allCommentsSlice = createSlice({
  name: 'allComments',
  initialState,
  reducers: {
    setHTMLSubtitle: (state: IAllCommentState, action) => {
      const apiResponse = action.payload;
      if (!isEqual(state, apiResponse)) {
        state.apiResponse = apiResponse;
      }
      return state;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(loadAllComments.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(loadAllComments.fulfilled, (state, action) => {
      const apiResponse = action.payload;
      if (apiResponse) {
        state.isLoading = false;
        state.apiResponse = apiResponse;
        state.comments=apiResponse.values;
        state.commentCount= "See" + " " + apiResponse.commentCount + " " + "comments";
        state.commentMood = apiResponse.commentMood;

        const {avidLabel, surveyLabel, periodLabel, segmentName, segmentCategory, question} = apiResponse;
        state.subtitle = avidLabel + ' ' + '|' + ' ' + surveyLabel + ' ' + '|' + ' ' +periodLabel;
        if (segmentName.length){
          state.subtitle +=  ' ' + '|' + ' ' + segmentCategory + ':' + segmentName
        };
        if (question.length){
          state.subtitle += ' ' + '|' + ' ' + question;
        }

      }
    });
  },
})

export const selectAllCommentsState = (state: RootState) =>
  state.allComments
export default allCommentsSlice.reducer;
